import { isValidCPF } from "@/utils/format-cps";
import { CPF_LENGTH } from "@/utils/cpf-mask";

export function normalizeCpf(raw: string): string {
  return (raw ?? "").replace(/\D/g, "").slice(0, CPF_LENGTH.WITHOUT_MASK);
}

export function isCompleteValidCpf(raw: string): boolean {
  const digits = normalizeCpf(raw);
  return digits.length === CPF_LENGTH.WITHOUT_MASK && isValidCPF(digits);
}

export function dedupeCpfs(list: string[]): string[] {
  const seen = new Set<string>();
  const result: string[] = [];
  for (const item of list) {
    const digits = normalizeCpf(item);
    if (!digits || seen.has(digits)) continue;
    seen.add(digits);
    result.push(digits);
  }
  return result;
}

export function buildCpfCsvFile(
  cpfs: string[],
  filename = "segmentacao-cpfs.csv",
): File {
  const content = dedupeCpfs(cpfs).join("\r\n");
  return new File([content], filename, { type: "text/csv" });
}
